import styled from 'styled-components'

export const ContainerAbastecimento = styled.div`
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  padding: 5px;
  overflow: hidden;
`